module.exports = __webpack_public_path__ + "static/home-6-1-phone-aed0e83b0ef5782a985b7351dbacc9cd.png";